/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Split patches</h4>

<p>Split selected face(s) by connecting the middles of its surrounding edges.</p>

<p>If Shift is held down when the button is clicked, the selected face(s) will be split by connecting its surrounding vertices. </p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('556486974')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>S</b>: Split patch at the middles of its edges</li>
    <li class='shortcuts__item'><b>Shift-S</b>: Split patch at its vertices</li>
</ul>`;

export default function SplitpatchTooltip() {
    return h('div', { innerHTML: body });
}
